export const CLIENT = 'radikle';
export const AUTH_CLIENT = 'radikle-auth';
export const OAUTH_URI = 'https://api.radikle.com/oauth';
export const API_BASE_URI = 'https://api.radikle.com';
export const API_URI = 'https://api.radikle.com/api';
export const ACCOUNTS_URI = 'https://accounts.radikle.com';
export const APP_URI = 'https://app.radikle.com'
